import { createSlice } from '@reduxjs/toolkit'
import { configFormsTexts } from 'locale/es'
import FormsService from 'services/FormsService'
import { toast } from './notificationReducer'

const initialState = { data: [], loading: false, error: null }

const formSlice = createSlice({
  name: 'formsConfig',
  initialState,
  reducers: {
    setForms(state, action) {
      const { data } = action.payload
      return { ...state, data, loading: false, error: null }
    },
    updateForm(state, action) {
      const updatedState = state.data.map((form) =>
        form.id !== action.payload.id ? form : action.payload
      )

      return { ...state, data: updatedState, loading: false, error: null }
    },
    setFormsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setFormsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetFormsConfigState(state, action) {
      return initialState
    }
  },
})

export const { setForms, updateForm, setFormsLoading, setFormsError, resetFormsConfigState } =
  formSlice.actions

export const initializeConfigForms = (centerId) => {
  return async (dispatch) => {
    try {
      dispatch(setFormsLoading())

      const { data } = await FormsService.getAll(centerId)
      dispatch(setForms({ data }))
    } catch (error) {
      console.error(error)
      dispatch(setFormsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(configFormsTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const createFormAction = (formObj, centerId) => {
  return async (dispatch, getState) => {
    try {
      const prevState = getState().formsConfig.data
      const { data } = await FormsService.create([...prevState, formObj], centerId)
      dispatch(setForms({ data }))
      dispatch(toast(configFormsTexts.CREATED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setFormsError({ message: error.message, status: error.response?.status }));
      // dispatch(toast(configFormsTexts.CREATION_ERROR, 'error'))
      throw error
    }
  }
}

export const updateFormAction = (updatedForm, centerId) => {
  return async (dispatch, getState) => {
    try {
      const prevState = getState().formsConfig.data
      const newState = prevState.map((form) =>
        form.formTag !== updatedForm.formTag ? form : updatedForm
      )
      const { data } = await FormsService.create(newState, centerId)
      dispatch(setForms({ data }))
      dispatch(toast(configFormsTexts.EDITED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setFormsError({ message: error.message, status: error.response?.status }));
      // dispatch(toast(configFormsTexts.EDITED_ERROR, 'error'))
      throw error
    }
  }
}

export const deleteFormAction = (centerId, formTag) => {
  return async (dispatch, getState) => {
    try {
      const prevState = getState().formsConfig.data
      const newState = prevState.filter((form) => form.formTag !== formTag)
      const { data } = await FormsService.create(newState, centerId)
      dispatch(setForms({ data }))
      dispatch(toast(configFormsTexts.DELETED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setFormsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(configFormsTexts.DELETED_ERROR, 'error'))
    }
  }
}

export default formSlice.reducer